module.exports = {
    barrel: {
        symbolsCount: 12,
        symbolNameFormat: "symbol_%d.png",
        blurNameFormat: "blur_%d.png",
        reels: 5,
        rows: 3,
        position: {x: 63, y: 130},
        cellSize: {width: 168, height: 168},
        reelGap: 14

    },

    symbol_animation_filename_pattern: "symbol_%d",
    lines_filename_pattern: "line_%d",
    frames_filename_pattern: "frame_%d",

    billets_on_filename_pattern: "billet_on_%d.png",
    billets_off_filename_pattern: "billet_off_%d.png",
    billets_coords: [
        {x:13, y:373},
        {x:13, y:245},
        {x:13, y:501},
        {x:0, y:179},
        {x:0, y:563},
        {x:0, y:211},
        {x:0, y:531},
        {x:0, y:403},
        {x:0, y:339},
        {x:981, y:195},
        {x:994, y:547},
        {x:994, y:347},
        {x:994, y:395},
        {x:994, y:227},
        {x:981, y:515},
        {x:981, y:259},
        {x:994, y:483},
        {x:13, y:195},
        {x:13, y:547},
        {x:981, y:595},
        {x:994, y:147}],

    scatter_frames_filename_pattern: "frame_0",
    
    animation_frames_count: [34,26,17,26,22,24,24,28,32,21,23,25],

    animation_speed: [
        0.1,
        0.1,
        0.1,
        0.1,
        0.1,
        0.1,
        0.15,
        0.1,
        0.1,
        0.1,
        0.1,
        0.1
    ]
};


//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 21
// module chunks = 0